/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Events', function($scope, $http, $q) {
    $scope.events = [];

    $scope.options = {
        currentPage: 1,
        totalItems: 1,
        perPage: 1,
        name: {
            model: {
                value: "",
                symbol: "text"
            }
        },
        surname: {
            model: {
                value: "",
                symbol: "text"
            }
        },
        action: {
            model: {
                value: "",
                symbol: "text"
            },
        },
        dateFrom: {
            model: {
                value: null,
                symbol: "dateFrom"
            }
        },
        dateTo: {
            model: {
                value: null,
                symbol: "dateTo"
            }
        },
        api_system: {
            model: {
                value: null,
                symbol: "apiSystem"
            }
        }
    };

    $scope.clearFilters = function() {
        $scope.options = {
            currentPage: 1,
            totalItems: 1,
            perPage: 1,
            name: {
                model: {
                    value: "",
                    symbol: "text"
                }
            },
            surname: {
                model: {
                    value: "",
                    symbol: "text"
                }
            },
            action: {
                model: {
                    value: "",
                    symbol: "text"
                },
            },
            dateFrom: {
                model: {
                    value: null,
                    symbol: "dateFrom"
                }
            },
            dateTo: {
                model: {
                    value: null,
                    symbol: "dateTo"
                }
            },
            api_system: {
                model: {
                    value: null,
                    symbol: "api_system"
                }
            }
        };
        $scope.onFilter();
    };

    $scope.onFilter = function() {
        $scope.getResults().then(function(result) {
            $scope.events = result.events;
        });
    };

    $scope.onFilterRun = function() {

    };

    $scope.archive = function() {
        $http.get('/administration/events/archive')
            .success(function() {
                $scope.onFilter();
            });
    };

    $scope.showLoader = false;
    $scope.getResults = function() {
        var p = $q.defer();
        $scope.showLoader = true;
        $http.post('/administration/events/getlist', $scope.options)
            .success(function(result) {
                $scope.options.totalItems = result.totalItems;
                $scope.options.perPage = result.perPage;
                p.resolve(result);
                $scope.showLoader = false;
            });
        return p.promise;
    };

    $scope.show = false;
    $scope.init = function() {
        $q.all([
            $scope.getResults(),
            $http.get('/administration/events/getfilters')
        ]).then(function(values) {
            $scope.events = values[0].events;
            $scope.filters = values[1].data;
            $scope.show = true;
        });
    };
    $scope.init();
});
